<template>
<div>
    <sidebar-item :link="{ name: 'PLANO', icon: 'fas fa-newspaper text-info' }">
        <sidebar-item v-if="permissoes.planosRead" :link="{ name: 'PLANOS', path: '/planos', icon: 'fas fa-paste' }" />
        <sidebar-item v-if="permissoes.mensalidadeCreate" :link="{ name: 'GERAR MENSALIDADE', path: '/planos/mensalidade', icon: 'fas fa-sync' }" />
    </sidebar-item>
</div>
</template>

<script>
export default {
    name: 'SidebarPlano',
    data() {
        return {
            permissoes: this.$store.state.usuario.permissao
        }
    }
}
</script>

